import { useState, useEffect } from 'react';
import { BsSearch as Search } from 'react-icons/bs';
import { IoChevronDownOutline as DropDownArrow } from 'react-icons/io5';
import { useSearchParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import BorderWhiteButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderWhiteButtonV2';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import {FormGroup} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ManagementService from '@Helpers/URLHelpers/ManagementService';
import ErrorHandler from '@Root/ErrorHandler';
import '@Partials/_ComStyles.scss';
import '@Partials/_OverrideStyles.scss';
import './Filters.scss'

export default function Filters(props) {

    const [filters, setFilters] = useState(props.filters);
    const [searchQuery, setSearchQuery] = useState('');
    const [showVisibilityOptions, setShowVisibilityOptions] = useState(false);
    const [anchorVisibilityOptionsMenu, setAnchorVisibilityOptionsMenu] = useState(null);
    const [showAdvancedFilters] = useState(false);
    const [refresh, setRefresh] = useState(false);
    let [searchParams, setSearchParams] = useSearchParams();
    new ErrorHandler();
    new ManagementService();
    const className = 'filters';

    useEffect(() => {
        let searchParamQuery = searchParams.get('searchFormQuery');
        if(!!searchParamQuery){
            let filtersObj = filters;
            filtersObj.kaiziqResolveConnectionFilter.searchQuery = searchParamQuery;
            setFilters(filtersObj);
            props.onFilterChange(filtersObj);
            props.handleSearch();
        }
        setSearchQuery(searchParamQuery);
    }, [])

    const handleSearchQueryChange = (e) => {
        let sanitizedQuery = DOMPurify.sanitize(e.target.value);
        setSearchQuery(sanitizedQuery);
        let filtersObj = props?.filters;
        filtersObj.kaiziqResolveConnectionFilter.searchQuery = sanitizedQuery;
        props.onFilterChange(filtersObj);
        setSearchParams({'searchFormQuery': sanitizedQuery, type: 'form', subType: 'search'});
    }

    const handleVisibilityOptionsPopup = (event) => {
        if(!showVisibilityOptions){
            if(!!event) {
                setAnchorVisibilityOptionsMenu(event.currentTarget);
                setShowVisibilityOptions(true);
            }
        } else {
            setAnchorVisibilityOptionsMenu(null);
            setShowVisibilityOptions(false);
        }
    }

    const toggleVisibilityCheckbox = (visibility) => {
        let filtersObj = filters;
        if(!filtersObj?.kaiziqIssueConnectionFilter?.visibilityList) {
            filtersObj.kaiziqIssueConnectionFilter.visibilityList = [];
        }
        if(visibility === 'public') {
            if(filtersObj?.kaiziqIssueConnectionFilter?.visibilityList?.some((item) => item === 'public')) {
                let newVisibilityList = filtersObj?.kaiziqIssueConnectionFilter?.visibilityList?.filter((item) => item !== 'public');
                filtersObj.kaiziqIssueConnectionFilter.visibilityList = newVisibilityList;
            } else {
                filtersObj.kaiziqIssueConnectionFilter.visibilityList = [...filtersObj.kaiziqIssueConnectionFilter.visibilityList, 'public'];
            }
        }
        if(visibility === 'private') {
            if(filtersObj?.kaiziqIssueConnectionFilter?.visibilityList?.some((item) => item === 'private')) {
                let newVisibilityList = filtersObj?.kaiziqIssueConnectionFilter?.visibilityList?.filter((item) => item !== 'private');
                filtersObj.kaiziqIssueConnectionFilter.visibilityList = newVisibilityList;
            } else {
                filtersObj.kaiziqIssueConnectionFilter.visibilityList = [...filtersObj.kaiziqIssueConnectionFilter.visibilityList, 'private'];
            }
        }
        props.onFilterChange(filtersObj);
        setFilters(filtersObj);
        setRefresh(!refresh);
    }

    const handleSearchOnKeyPress = (e) => {
        if(e.keyCode === 13) {
            props.handleSearch();
        }
    }

    return (
        <div className= {className + ' width-wfa'} style={{cursor: props.cursor}}>
            <div className= {className + '__inner flex-column-flex-start width-wfa'}>
                <div className= {className + '__inner__top flex-row-center-1rem-gap width-wfa'}>
                    <div className={className + '__inner__search' + (props.smallDisplay ? '__small' : '')}>
                        <TextField
                            placeholder='Type the form ID ...'
                            value={searchQuery}
                            onChange={handleSearchQueryChange}
                            disabled={props.cursor === 'wait'}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment
                                        position='start'>
                                        <Search className={className + '__inner__search__searchIcon dashboard-icon'} />
                                    </InputAdornment>
                                ),
                                disableUnderline: true,
                                style: { fontSize: '1vw' }
                            }}
                            onKeyDown={handleSearchOnKeyPress}
                            className={className + '__inner__search__searchBar'} />
                    </div>
                    <div className={className + '__inner__search__button'}>
                        <BorderWhiteButtonV2
                            text='Search'
                            onClick={props.handleSearch}
                            disabled={props.cursor === 'wait'}/>
                    </div>
                </div>
                {
                    (showAdvancedFilters) &&
                        <div className={className + '__inner__filters flex-row-center-1vw-gap'}>
                            {
                                props.showVisibilityListFilter &&
                                    <div className={className + '__inner__filters__type '}>
                                        <div className={className + '__inner__filters__type__t1 flex-row-flex-end-0p5vw-gap standard-link'} onClick={handleVisibilityOptionsPopup}
                                            disabled={props.cursor === 'wait'}>
                                            Visibility ({filters?.kaiziqIssueConnectionFilter?.visibilityList?.length})
                                            <DropDownArrow className={className + '__inner__filters__type__icon'}/>
                                        </div>
                                        {
                                            showVisibilityOptions ?
                                                <Menu
                                                    open={showVisibilityOptions}
                                                    onClose={handleVisibilityOptionsPopup}
                                                    anchorEl={anchorVisibilityOptionsMenu}
                                                    disabled={props.cursor === 'wait'}
                                                    className={className + '__inner__filters__type__menu'}>
                                                    <div className={className + '__inner__filters__type__menu__flex flex-column-flex-start'}>
                                                        <MenuItem className={className + '__inner__filters__type__menu__option width-wfa dropdown-option-padding'} >
                                                            <FormGroup className={className + '__inner__filters__type__menu__option__check'}>
                                                                <FormControlLabel control={<Checkbox
                                                                    checked={filters?.kaiziqIssueConnectionFilter?.visibilityList?.some((visibility) => visibility === 'public')}
                                                                    onChange={() => toggleVisibilityCheckbox('public')}/>} label={
                                                                        <div>
                                                                            Public
                                                                        </div>
                                                                    }
                                                                    />
                                                            </FormGroup>
                                                        </MenuItem>
                                                        <MenuItem className={className + '__inner__filters__type__menu__option width-wfa dropdown-option-padding'} >
                                                            <FormGroup className={className + '__inner__filters__type__menu__option__check'}>
                                                                <FormControlLabel control={<Checkbox
                                                                    checked={filters?.kaiziqIssueConnectionFilter?.visibilityList?.some((visibility) => visibility === 'private')}
                                                                    onChange={() => toggleVisibilityCheckbox('private')}/>} label={
                                                                        <div>
                                                                            Private
                                                                        </div>
                                                                    }
                                                                    />
                                                            </FormGroup>
                                                        </MenuItem>
                                                    </div>
                                                </Menu>
                                            : null
                                        }
                                    </div>
                            }
                        </div>
                }
            </div>
        </div>
    )
}

Filters.defaultProps = {
  showVisibilityListFilter: true
}